<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'ProductIndex',
  data() {
    return {}
  },
  mounted() {
    console.log('【↑↑↑】', this.$options.name)
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/product/Index.vue